export default "__VITE_ASSET__604956d2__"